import React, { useState } from "react";
import {
  Container,
  Paper,
  Box,
  TextField,
  Button,
  Typography,
  Alert,
} from "@mui/material";
import { submitTwoFactor } from "../services/api";
import { useNavigate } from "react-router-dom";

export default function TwoFactorPage() {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await submitTwoFactor({ code });

      if (res.data?.token) {
        // Save token for authenticated requests
        localStorage.setItem("authToken", res.data.token);

        setSuccess("2FA verified successfully!");
        setTimeout(() => navigate("/dashboard"), 1200);
      } else {
        setError("Invalid code. Please try again.");
      }
    } catch (err) {
      setError("Verification failed. Please try again.");
    }

    setLoading(false);
  }

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 8 }}>
        <Typography variant="h5" mb={2} textAlign="center">
          Two‑Factor Authentication
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Enter 2FA Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            sx={{ mb: 3 }}
          />

          <Button
            fullWidth
            variant="contained"
            type="submit"
            disabled={loading}
          >
            {loading ? "Verifying..." : "Verify Code"}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
